import { ArrowRight, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { FEATURED_AI } from "@/data/site";

const FeaturedAI = () => (
  <section
    id="ai-solutions"
    data-testid="featured-ai-section"
    className="noise-overlay relative scroll-mt-24 overflow-hidden bg-navy py-24 md:py-32 lg:py-40"
  >
    <div
      aria-hidden
      className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-purple-500/10 blur-[130px]"
    />
    <div
      aria-hidden
      className="pointer-events-none absolute -left-40 bottom-0 h-[420px] w-[420px] rounded-full bg-electric/15 blur-[130px]"
    />

    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        dark
        overline="Featured AI Solutions"
        title="AI That Works For Your Business"
        text="Practical AI systems that answer customers, take bookings, qualify leads and connect your tools — around the clock."
      />

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {FEATURED_AI.map((solution, i) => (
          <Reveal key={solution.title} delay={i * 0.1} className="h-full">
            <div
              data-testid={`featured-ai-card-${solution.tag.toLowerCase()}`}
              className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-xl transition-[background-color,border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-electric/40 hover:bg-white/[0.08] hover:shadow-[0_0_40px_rgba(37,99,235,0.15)]"
            >
              <div className="flex items-center justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-electric/20 transition-transform duration-500 group-hover:scale-110">
                  <solution.icon className="h-6 w-6 text-cyan-400" strokeWidth={1.5} />
                </div>
                <span className="rounded-full border border-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
                  {solution.tag}
                </span>
              </div>
              <h3 className="mt-7 font-display text-2xl font-medium tracking-tight text-white">
                {solution.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{solution.text}</p>
              <ul className="mt-6 grid flex-1 grid-cols-2 gap-x-4 gap-y-2.5">
                {solution.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-xs text-slate-300">
                    <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-cyan-400" strokeWidth={2} />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-14 text-center">
        <a
          href="#contact"
          data-testid="featured-ai-build-solution-btn"
          className="group inline-flex items-center gap-2 rounded-full bg-electric px-8 py-4 font-medium text-white transition-[background-color,box-shadow,transform] duration-300 hover:scale-[1.02] hover:bg-electric-bright hover:shadow-[0_0_28px_rgba(37,99,235,0.5)] active:scale-95"
        >
          Build Your AI Solution
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </Reveal>
    </div>
  </section>
);

export default FeaturedAI;
